// extracted by mini-css-extract-plugin
export default {"description":"industry_description__+ZBSv","content":"industry_content__ShNTf"};